var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramUranium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 14,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 4C16.096 4 4 16.096 4 31s12.096 27 27 27 27-12.096 27-27S45.904 4 31 4Zm12.528 18.36c-.405 4.266-2.16 14.634-3.051 19.413-.378 2.025-1.134 2.7-1.836 2.781-1.566.135-2.754-1.026-4.266-2.025-2.376-1.566-3.726-2.538-6.021-4.05-2.673-1.755-.945-2.727.594-4.293.405-.405 7.317-6.696 7.452-7.263a.538.538 0 0 0-.135-.486c-.162-.135-.378-.081-.567-.054-.243.054-4.023 2.565-11.394 7.533-1.08.729-2.052 1.107-2.916 1.08-.972-.027-2.808-.54-4.185-.999-1.701-.54-3.024-.837-2.916-1.782.054-.486.729-.972 1.998-1.485 7.884-3.429 13.122-5.697 15.741-6.777 7.506-3.132 9.045-3.672 10.071-3.672.216 0 .729.054 1.053.324.27.216.351.513.378.729-.027.162.027.648 0 1.026Z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 40.346,
    y1: 16.981,
    x2: 19.577,
    y2: 46.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramUranium);
export default __webpack_public_path__ + "static/media/telegram-uranium.a1cbcce41719b77e2c63ab57843c48f7.svg";
export { ForwardRef as ReactComponent };